import { makeAutoObservable } from "mobx";
import { getRequest, putRequest } from "../lib/axios/request";

export class ApprovalStore {
    /**
     *  State
     */
    approval_data = null as any;
    approval_status_filter = 'pending';
    selected_approval_data = null as any;
    // Toggle
    success_alert_toggle = false as boolean;

    /**
     *  Constructor
     */
    constructor() {
        makeAutoObservable(this)
    }

    /**
     *  Common Method
     */
    async setSelectedApproval(data: any) {
        this.selected_approval_data = data;
    }
    async setApprovalStatus(status: string) {
        this.approval_status_filter = status;
    }
    // Set Success Alert Toggle
    setSuccessAlertToggle(value: boolean) {
        this.success_alert_toggle = value;
    }

    /**
     *  Request Method
     */
    async getApprovalList() {
        const response = await getRequest(`/approval/list?page=1&limit=10&sort_by=request_date&sort_order=desc&status=${this.approval_status_filter}`, {});

        if(response.data) {
            this.approval_data = response.data;
        }
    }

    async approveRequest(id: string) {
        const response = await putRequest(`/approval/approve/${id}`, {}, {});

        if(response) {
            //alert('Request berhasil diapprove!');
            this.setSuccessAlertToggle(true);
            window.location.href = 'menu/approval-center';
        }
    }

    async rejectRequest(id: string) {
        const response = await putRequest(`/approval/reject/${id}`, {}, {});

        if(response) {
            //alert('Request berhasil direject!');
            this.setSuccessAlertToggle(true);
            window.location.href = 'menu/approval-center';
        }
    }

    async approveMultiple(ids: string[]) {
        await Promise.all(ids.map((id) => putRequest(`/approval/approve/${id}`, {}, {})));

        this.setSuccessAlertToggle(true);
        await this.getApprovalList();
    }
}

const approvalStore = new ApprovalStore();
export default approvalStore;